import { createAction, createReducer } from '@reduxjs/toolkit';

const NEW_BATCH = createAction('properties/newBatch');
const START_LOADING = createAction('properties/startLoading');
const FINISHED_LOADING = createAction('properties/finishLoading');

export const actions = {
  NEW_BATCH,
  START_LOADING,
  FINISHED_LOADING,
};

function finishLoading(prev) {
  return { ...prev, loading: false };
}

function startLoading(prev) {
  return { ...prev, loading: true };
}

function newBatch(prev, action) {
  const list = [...prev.list, ...action.payload];
  return { ...prev, touched: true, list };
}

const reducer = createReducer(
  {
    loading: false,
    touched: false,
    list: [],
  },
  {
    [NEW_BATCH]: newBatch,
    [FINISHED_LOADING]: finishLoading,
    [START_LOADING]: startLoading,
  }
);

export default reducer;
